'use client'

import { Popover, PopoverBackdrop, PopoverButton, PopoverPanel } from '@headlessui/react'
import _ from 'lodash'
import Link from 'next/link'
import { memo } from 'react'
import { createPortal } from 'react-dom'
import { HiChevronDown } from 'react-icons/hi'
import { researchPages } from '@/settings'
import { ToggleBodyScroll } from './toggleBodyScroll'

// Components
const ResearchMenuItem = memo(({ page, index, onClick }: { page: { href: string; name: string }; index: number; onClick: () => void }) => (
  <Link hrefLang='en' key={`navResearch_${index}`} href={page.href} className='menu-item' onClick={onClick}>
    {page.name}
  </Link>
))

export const HeaderResearchMenu = memo(() => {
  return (
    <Popover as='div' className='relative'>
      {({ open, close }) => (
        <>
          <ToggleBodyScroll open={open} />
          {open &&
            typeof document !== 'undefined' &&
            createPortal(<PopoverBackdrop className='dialog-backdrop z-10!' onClick={close} />, document.body)}
          <PopoverButton className='menu-button font-semibold dark:font-medium' aria-label='Research Menu'>
            <span>Research</span>
            <HiChevronDown aria-hidden='true' className='-mr-1 ml-1 size-4' />
          </PopoverButton>
          <PopoverPanel
            as='nav'
            aria-label='Research Submenu'
            anchor='bottom start'
            transition={true}
            modal={false}
            unmount={false}
            className='menu-items rounded-r-md pt-2 pb-4'
          >
            {_.map(researchPages, (page, idx) => (
              <ResearchMenuItem key={`navResearch_${idx}`} page={page} index={idx} onClick={close} />
            ))}
          </PopoverPanel>
        </>
      )}
    </Popover>
  )
})
